import { useRef } from 'react';
import { Button, Heading, Input, Link, Text, VStack } from 'components/ui';
import styled from '@emotion/styled';
import { useLogin } from '../../hooks/useLogin';
import { useNavigateWithParams } from '../../hooks/useNavigateWithParams';
import { ContactSupport } from '../OnboardingForm/ContactSupport';

const InputRow = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  & > * {
    margin-bottom: 0 !important;
  }
`;

export const LoginForm = () => {
  const navigate = useNavigateWithParams();
  const loginEmailRef = useRef<HTMLInputElement>(null);
  const { isLoading, loginMessage, sendNewLoginLink } = useLogin();

  const handleSendLoginLink = () => {
    const email = loginEmailRef?.current?.value;
    if (!email) return;
    sendNewLoginLink(email);
  };

  return (
    <VStack gap={16} alignItems="center" w="348px" maxW="100%">
      <VStack gap={4} w="100%">
        <VStack gap={3} w="100%" maxW="291px" mx="auto">
          <Heading color="secondary.500" fontSize="4xl">
            Welcome back!
          </Heading>
          <Text
            color="secondary.500"
            fontSize="sm"
            fontWeight="normal"
            textAlign="center"
          >
            To sign in, enter your email and we’ll send you a magic link to
            confirm your identity. This is the safest way to protect your data!
          </Text>
        </VStack>

        <VStack alignItems="center" justifyContent="center" minH="17px">
          {!!loginMessage && (
            <Text
              color="secondary.200"
              fontWeight="bold"
              textAlign="center"
              style={{ whiteSpace: 'nowrap' } as any}
            >
              {loginMessage}
            </Text>
          )}
        </VStack>

        <InputRow>
          <Input
            ref={loginEmailRef}
            type="text"
            placeholder="Email"
            rounded="full"
            borderColor="steel.200"
            bg="white"
            w="100%"
            maxW="340px"
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSendLoginLink();
            }}
          />
        </InputRow>

        <Button
          bg="secondary.500"
          rounded="full"
          w="100%"
          maxW="342px"
          alignSelf="center"
          disabled={isLoading}
          loading={isLoading}
          onClick={handleSendLoginLink}
        >
          <Text
            color="white"
            fontSize="md"
            fontWeight="semibold"
            textTransform="none"
          >
            Send login link
          </Text>
        </Button>

        <Text color="secondary.500" fontWeight="normal" textAlign="center">
          First time here?{' '}
          <Link
            color="aqua.500"
            fontWeight="bold"
            isExternal={false}
            isUnderlined={false}
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          >
            Create an account
          </Link>
        </Text>
      </VStack>

      <ContactSupport />
    </VStack>
  );
};
